import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Errors from "../Errors/Errors";
import LoginProviders from "./LoginProviders";

export default class SignIn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      loading: false,
      email: '',
      password: '',
      property: '',
      properties: [],
      showPassword: false,
      user: null,
      otp: '',
      step: 'sign_in',
      email_hint: '',
      phone_hint: '',
      communication_method: 'email'
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeProperty = this.onChangeProperty.bind(this);
    this.onChangeErrors = this.onChangeErrors.bind(this);
    this.onNotThisUser = this.onNotThisUser.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onVerify = this.onVerify.bind(this);
    this.onTogglePassword = this.onTogglePassword.bind(this);
  }

  render() {
    if (this.state.step == 'sign_in') {
      return (
        <form onSubmit={this.onSubmit} style={{ position: "relative" }}>
          <Errors errors={this.state.errors} />
  
          {this.props.google_sign_in !== false && (
            <LoginProviders
              property={this.props.property}
              onChangeErrors={this.onChangeErrors}
            />
          )}
  
          {
            this.state.properties.length > 0 
            ? 
            this.renderPropertySelect()
            :
            this.renderSignIn()
          }
  
          <LoadingSpinner
            backgroundColor="rgba(32,33,46,0.5)"
            size="small"
            show={this.state.loading}
          />
        </form>
      );
    } else if (this.state.step == 'verification-method') {
      return (
        <form onSubmit={this.onSelect} style={{ position: "relative" }}>
          <Errors errors={this.state.errors} />

          {this.renderPreferredMethod()}

          <LoadingSpinner
            backgroundColor="rgba(32,33,46,0.5)"
            size="small"
            show={this.state.loading}
          />
        </form>
      );
    } else if (this.state.step == 'verification-code') {
      return (
        <form onSubmit={this.onVerify} style={{ position: "relative" }}>  
          {
            this.state.properties.length > 0 
            ? 
            this.renderPropertySelect()
            :
            this.renderVerification()
          }
  
          <LoadingSpinner
            backgroundColor="rgba(32,33,46,0.5)"
            size="small"
            show={this.state.loading}
          />
        </form>
      );
    }
  }

  renderSignIn() {
    return (
      <div>
        <div className="form-group">
          <label>{I18n.t("email")}</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={this.state.email}
            onChange={this.onChange}
          />
        </div>

        <div className="form-group">
          <label>{I18n.t("password")}</label>
          <div
            style={{
              position: "relative",
            }}
          >
            <input
              type={this.state.showPassword ? "text" : "password"}
              name="password"
              className="form-control"
              value={this.state.password}
              onChange={this.onChange}
            />
            <span
              className={`fa fa-fw ${
                this.state.showPassword ? "fa-eye fa-eye-slash" : "fa-eye"
              }`}
              onClick={this.onTogglePassword}
              style={{
                position: "absolute",
                cursor: "pointer",
                top: "11px",
                right: "6px",
                color: "#555",
              }}
            ></span>
          </div>
        </div>

        <div className="actions">
          <button type="submit" className="btn btn-block btn-primary">
            {I18n.t("sign_in")}
          </button>
        </div>

        <div className="mt-3">
          <a href={this.props.forgot_password_path}>
            {I18n.t("forgot_password")}
          </a>
        </div>
    </div>
    )
  }

  renderPreferredMethod() {
    return (
      <div>
        <div className='form-group'>
          <label>{I18n.t('preferred_communication_method')}</label>
          <div className='row px-4 align-items-start'>
            <input type='radio' id='email' className='col-sm-2 m-0 mt-1' style={{maxWidth: '13px'}} name='communication_method' value='email' onClick={this.onChange}/>
            <p className='col-sm-9'>{I18n.t('send_email_to', { email: this.state.email_hint })}</p>
          </div>
          <div className='row px-4 align-items-start'>
            <input type='radio' id='phone' className='col-sm-2 m-0 mt-1' style={{maxWidth: '13px'}} name='communication_method' value='text' onClick={this.onChange}/>
            <p className='col-sm-9'>{I18n.t('send_text_to', { phone: this.state.phone_hint ? this.state.phone_hint : I18n.t('na') })}</p>
          </div>
        </div>

        <div className='actions'>
          <button type='submit' className='btn btn-block btn-primary'>
            {I18n.t('send_code')}
          </button>
        </div>
    </div>
    )
  }

  renderVerification() {
    return (
      <div>
        <div className='alert alert-success alert-dismissible fade show' role='alert'>
          {I18n.t('verification_code_sent')}
        </div>
        <div className='form-group'>
          <label>{I18n.t('verification_code')}</label>
          <input
            type='otp'
            name='otp'
            className='form-control'
            value={this.state.otp}
            onChange={this.onChange}
          />
        </div>

        <div className='actions'>
          <button type='submit' className='btn btn-block btn-primary'>
            {I18n.t('sign_in')}
          </button>
        </div>
    </div>
    )
  }

  renderPropertySelect() {
    const { user } = this.state;
    const { first_name, last_name } = user;

    return (
      <div>
        <h4 className="text-center" style={{marginBottom: '5px'}}>{I18n.t('welcome_back')}, {`${first_name} ${last_name}`}!</h4>
        <p className="text-center"><a href="#" onClick={this.onNotThisUser}>{I18n.t('sign_in_as_a_different_user')}</a></p>
        <p style={{marginTop: '30px', marginBottom: '10px'}}>{I18n.t('please_select_the_property_youd_like_to_access')}:</p>
        <div className="form-group">
          <select name="select_property" id="select_property" value={this.state.property} className="form-control" onChange={this.onChangeProperty}>
            {this.state.properties.map((property) => (
              <option key={property.admin_root_path} value={property.admin_root_path}>{property.name}</option>
            ))}
          </select>
        </div>
        <div className="actions">
          <button type="submit" className="btn btn-primary">
            {I18n.t("sign_in")}
          </button>
        </div>
      </div>
    )
  }

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onChangeProperty(e) {
    this.setState({ property: e.target.value })
  }

  onChangeErrors(errors) {
    this.setState({ errors: errors });
  }

  onNotThisUser(e) {
    e.preventDefault();

    this.setState({ properties: [], property: "", user: null, email: "", password: "" });
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.state.user && this.state.property) {
      window.location.href = this.state.property;
    } else {
      this.setState({ loading: true });

      $.ajax({
        type: "POST",
        url: this.props.sign_in_path,
        data: {
          email: this.state.email,
          password: this.state.password,
        },
      }).done((data) => {
        if (data.status === 'verification_required') {
          this.setState({ loading: false, errors: [], step: 'verification-method', email_hint: data.email_hint, phone_hint: data.phone_hint });
        } else if (data.errors && data.errors.length) {
          this.setState({ loading: false, errors: data.errors });
        } else if (data.properties && data.properties.length) {
          this.setState({ loading: false, errors: [], properties: data.properties, property: data.properties[0].admin_root_path, user: data.user });
        } else {
          window.location.href = data.redirect_to;
        }
      });
    }
  }

  onSelect(e) {
    e.preventDefault();
    e.stopPropagation();
  
    this.setState({ loading: true });
    $.ajax({
      type: "GET",
      url: this.props.verification_method_path,
      data: {
        email: this.state.email,
        communication_method: this.state.communication_method
      },
    }).done((data) => {
      if (data.status === 'verification_code') {
        this.setState({ loading: false, errors: [], step: 'verification-code' });
      }
    });
  }

  onVerify(e) {
    e.preventDefault();
    e.stopPropagation();
  
    if (this.state.user && this.state.property) {
      window.location.href = this.state.property;
    } else {
      this.setState({ loading: true });

      $.ajax({
        type: "POST",
        url: this.props.two_factor_path,
        data: {
          email: this.state.email,
          otp: this.state.otp,
        },
      }).done((data) => {
        if (data.status === 'verification_required') {
          this.setState({ loading: false, errors: data.errors, step: 'verification-method', otp: '', email_hint: data.email_hint, phone_hint: data.phone_hint });
        } else if (data.errors && data.errors.length) {
          this.setState({ loading: false, errors: data.errors });
        } else if (data.properties && data.properties.length) {
          this.setState({ loading: false, errors: [], properties: data.properties, property: data.properties[0].admin_root_path, user: data.user });
        } else {
          window.location.href = data.redirect_to;
        }
      });
    }
  }

  onTogglePassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
}
